import { ReactNode } from 'react';

import { Box, SpacingValues } from '../Box';

/**
 * Свойства компонента {@link Descriptions}
 */
interface DescriptionsProps {
  /**
   * Дочерние элементы, которые будут отображены внутри компонента.
   */
  children: ReactNode;

  /**
   * Отступ между дочерними элементами.
   * Допустимые значения определены в типе SpacingValues.
   *
   * @defaultValue `'8'`
   */
  gapBetweenItems?: SpacingValues;
}

/**
 * Компонент Descriptions представляет собой контейнер для описаний,
 * который отображает дочерние элементы в виде вертикального списка с заданным отступом между ними.
 *
 * @public
 * @param children - Дочерние элементы, которые будут отображены внутри компонента.
 * @param gapBetweenItems - Отступ между дочерними элементами.
 * @returns  Элемент React, представляющий компонент Descriptions.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link DescriptionsProps}
 */
export const Descriptions = ({
  children,
  gapBetweenItems = '8',
}: DescriptionsProps) => (
  <Box
    display="flex"
    flexDirection="column"
    gap={gapBetweenItems}
    p="16"
    bgcolor="bg.greyscale.primary"
    radius="l"
    testId="descriptions-test-id"
  >
    {children}
  </Box>
);
